import styled from 'styled-components';
import { colors } from '../../constants';

export const InvoiceAnchor = styled.a`
  color: ${colors.red};
  &:hover {
    cursor: pointer;
  }
`;
